module.exports = __webpack_public_path__ + "img/yl_active@3x.8e82a6f2.png";